import React from 'react';

// Elements
import Footer from '../../components/elements/Footer';
import Demonstration from '../../components/demo/Demonstration';
import Toolbar from '../../components/elements/Toolbar';

const HomeView = () => {
  return (
    <div className="view-home">
      <header className="header">
        <div className="container">
          <Toolbar />
          <div className="row sp-xs-top-3">
            <div className="col-md-10 offset-md-1 text-xs-center">
              <h1 className="text-light text-weight-light">Base Kit</h1>
              <p className="text-lg text-muted text-light">An awesome kit with components like Modal, Dropdown, Slide, NavigationDrawer and some really good styles (based on Bootstrap 4) written in scss.</p>
              <a href="https://github.com/vinpac/base-kit" className="btn btn-primary btn-shadow text-uppercase sp-xs-right-2 sp-sm-bottom-none"><i className="fa fa-github-alt sp-xs-right-1" aria-hidden="true"></i>View on GitHub</a>
              <a href="https://github.com/vinpac/base-kit/issues" className="btn btn-text-accent btn-shadow text-uppercase sp-xs-right-2 sp-sm-bottom-none bg-light">Open issue</a>
            </div>
          </div>
        </div>
      </header>
      <Demonstration />
      <div className="container section-padding">
        <div className="row">
          <div className="col-lg-5 offset-lg-1">
            <h5 className="text-uppercase text-success text-weight-semibold">Always improving</h5>
            <p className="text-muted-dark">Stripe is an always-improving toolchain that gains new features every month. Our world-class engineering team constantly iterates upon every facet of the Stripe stack. And from Apple Pay to Bitcoin, building on Stripe means you get early access to the latest technologies.</p>
            <a href="" className="sp-xs-top-1 text-accent text-weight-semibold">Lear about Stripe's products <i className="fa fa-arrow-right sp-xs-left-1"></i></a>
          </div>
          <div className="col-lg-5 sp-xs-top-2 sp-lg-top-none">
            <h5 className="text-uppercase text-success text-weight-semibold">Always improving</h5>
            <p className="text-muted-dark">Stripe is an always-improving toolchain that gains new features every month. Our world-class engineering team constantly iterates upon every facet of the Stripe stack. And from Apple Pay to Bitcoin, building on Stripe means you get early access to the latest technologies.</p>
            <a href="" className="sp-xs-top-1 text-accent text-weight-semibold">Lear about Stripe's products <i className="fa fa-arrow-right sp-xs-left-1"></i></a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

HomeView.displayName = 'HomeView';

export default HomeView;



/** WEBPACK FOOTER **
 ** ./src/routes/home/HomeView.js
 **/